export default (node) => {
  const showFilters = node.querySelector('[data-show-filters]');
  const hideFilters = node.querySelector('[data-hide-filters]');
  const filtersContainer = node.querySelector('[data-filters-container]');
  const filterSelects = node.querySelectorAll('[data-filter-tag]');
  const collectionHandle = node.querySelector('[data-filters-container]')
    .dataset.filtersContainer;

  const getFiltersFromUrl = () => {
    const currentUrl = window.location.pathname;
    // from the currentUrl, get all after /collections/${collectionHandle}
    let filters = currentUrl.match(
      new RegExp(`/collections/${collectionHandle}(.*)`)
    );

    filters = filters[1];
    // if the first character is /, remove it
    if (filters[0] === '/') {
      filters = filters.slice(1);
    }

    return filters;
  };

  const handleFilterSelect = (select) => {
    const filterTag = select.dataset.filterTag;
    let filterValue = select.value;
    if (filterTag === 'filter-color') {
      filterValue = select.querySelector('[data-color-filter-radio]').value;
    }

    const currentUrl = window.location.pathname;

    const filters = getFiltersFromUrl();

    if (filters && filters.length > 0) {
      // the filters are separated by +, find if the current filterTag is in the filters
      const currentFilter = filters
        .split('+')
        .find((filter) => filter.includes(filterTag));
      if (currentFilter) {
        // replace the filterValue with the new filterValue
        let newUrl = '';
        if (filterValue.length > 0) {
          newUrl = currentUrl.replace(
            currentFilter,
            `${filterTag}:${filterValue}`
          );
        } else {
          // remove the filter
          newUrl = currentUrl.replace(`+${currentFilter}`, '');
          newUrl = newUrl.replace(`${currentFilter}+`, '');
          newUrl = newUrl.replace(`${currentFilter}`, '');

          window.location.pathname = newUrl;
        }
        window.location.pathname = newUrl;
      } else {
        // not found, add the new filter, check if there are other filters
        const otherFilters = filters
          .split('+')
          .filter((filter) => filter !== currentFilter);
        if (otherFilters.length > 0) {
          // add the new filter
          window.location.pathname = `/collections/${collectionHandle}/${filterTag}:${filterValue}+${otherFilters.join('+')}`;
        } else {
          // no other filters, add the new filter
          window.location.pathname = `/collections/${collectionHandle}/${filterTag}:${filterValue}`;
        }
      }
    } else {
      window.location.pathname = `/collections/${collectionHandle}/${filterTag}:${filterValue}`;
    }
  };

  const init = () => {
    showFilters.addEventListener('click', () => {
      filtersContainer.classList.remove('hidden');
      showFilters.classList.add('!hidden');
      hideFilters.classList.remove('!hidden');
    });

    hideFilters.addEventListener('click', () => {
      filtersContainer.classList.add('hidden');
      showFilters.classList.remove('!hidden');
      hideFilters.classList.add('!hidden');
    });

    filterSelects.forEach((select) => {
      select.addEventListener('change', () => handleFilterSelect(select));
    });
  };

  init();
};
